// The splash the open-elsewhere state replaced, to put back when this tab starts.
let splash: Array<Node> = [];

function replaceBootShell(...children: Array<Node>) {
  document.getElementById("boot-shell")?.replaceChildren(...children);
}

/** Shows startup failures before React can replace the boot splash. */
export function showBootError(error: unknown) {
  console.error("HeyDex failed to start.", error);
  if (!document.getElementById("boot-shell")) return;
  const content = document.createElement("div");
  content.id = "boot-error";
  content.setAttribute("role", "alert");

  const message = document.createElement("p");
  message.textContent = "HeyDex could not load.";
  content.append(message);

  if (import.meta.env.DEV && error instanceof Error) {
    const detail = document.createElement("p");
    detail.textContent = error.message;
    content.append(detail);
  }

  const reload = document.createElement("button");
  reload.type = "button";
  reload.textContent = "Reload";
  reload.addEventListener("click", () => window.location.reload());
  content.append(reload);
  replaceBootShell(content);
}

/** Another tab runs this reader's HeyDex; this one waits and starts when that tab closes. */
export function showOpenInAnotherTab() {
  const content = document.createElement("div");
  content.id = "boot-error";
  content.setAttribute("role", "status");
  const title = document.createElement("p");
  title.textContent = "HeyDex is open in another tab.";
  const detail = document.createElement("p");
  detail.textContent = "It opens here when you close it there.";
  content.append(title, detail);
  splash = Array.from(document.getElementById("boot-shell")?.childNodes ?? []);
  replaceBootShell(content);
}

/** Puts the boot splash back once this tab can start. */
export function showBootSplash() {
  replaceBootShell(...splash);
}
